import { useQuery } from 'react-query';
import { getOpportunities } from '../../apis/V2/opportunities';

export interface OpportunityType {
	badgesRequired: [
		{ createdAt: string; name: string; updatedAt: string; meta: { badgeCard: string; badgeIcon: string; disabledBadgeTagLine: string } },
	];
	companyLogo: string;
	companyName: string;
	location: string;
	pencentileRequired: string;
	rating: string;
	role: string;
	salaryRange: string;
	workType: string;
	_id: string;
}

export const useOpportunies = () => {
	return useQuery({
		queryKey: 'getOpportunities',
		queryFn: async () => (await getOpportunities()).data?.data as OpportunityType[],
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
		enabled: true,
	});
};
